import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: ${({ theme }) => theme.space[6]};
    padding-bottom: ${({ theme }) => theme.space[5]};
    margin-top: 24px;

    ${breakpointUp.md`
        flex-direction: row;
        padding: 0;
    `}
`;
